import api from './axios';

// 공통코드 조회
export const cmmSend = async ( sendPath, paramData ) => {
    const response = await api.post(`/knouComm${sendPath}`, paramData);
    return response.data;
};

// 공통코드 조회
export const cmmCd = async ( comCd ) => {
    const response = await api.post('/knouComm/com/getComCdList', { grpCd: comCd } );
    return response.data;
};

// 레벨처리 콤보 조회
export const cmmLevelCmb = async ( ctgrCd, cmbCtgy ) => {
    let sendPath;
    let cmmUpGrpCd;
    
    if( ctgrCd === '100002' ) {
        sendPath = '/com/getMidComCdList';
        cmmUpGrpCd = '100001';
    } else if( ctgrCd === '100003' ) {
        sendPath = '/com/getSmllComCdList';
        cmmUpGrpCd = '100002';
    } else {
        sendPath = '/com/getMajorComCdList';
    }
    cmbCtgy = { ...cmbCtgy, commonUpGroupCode: cmmUpGrpCd, commonGroupCode: ctgrCd, grpCd : ctgrCd }

    const response = await api.post(`/knouComm${sendPath}`, cmbCtgy );
    return response.data;
};

// vlab 게시판 목록 가져오기
export const selectBoxList = async (searchData) => {
  //const response = await api.get(`/knouVLab/getBoardList?page=${searchData.page}&pageSize=${searchData.pageSize}`);
  const response = await api.get('/knouVLab/getSelectBox',{params: searchData});
  return response.data;
};

